import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { FlexColumn } from '../../atoms/layout/Flex'
import { JobActions } from '../../../store/job'
import Button from '../../atoms/inputs/Button'
import { CompanyActions } from '../../../store/company'
import { CompanySelectors } from '../../../store/company/selectors'
import CompanyWorkAreaChecks from './CompanyWorkAreaChecks'

export default function CompanyWorkAreas() {
  const company = useSelector(CompanySelectors.company)
  const dispatch = useDispatch()
  const [selectedAreaIds, setSelectedAreaIds] = useState<string[]>(company?.workAreaIds ?? [])

  useEffect(() => {
    if (company) {
      setSelectedAreaIds(company.workAreaIds)
    }
  }, [company])

  useEffect(() => {
    dispatch(JobActions.fetchJob())
  }, [dispatch])

  const handleSave = () => {
    dispatch(CompanyActions.saveWorkAreas({ areaIds: selectedAreaIds }))
  }

  return (
    <FlexColumn>
      <Button onClick={handleSave}>保存</Button>
      <CompanyWorkAreaChecks areaIds={selectedAreaIds} onChange={setSelectedAreaIds} />
    </FlexColumn>
  )
}
